import React from 'react'
import ReactPlayer from 'react-player'


function ManualComercial() {
  return (
    <div>
           <div className="container">
        <div className="text-center">
          <div class="container-fluid">
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">Manual uso  Comercial</h6>
                <br></br>
        <center>
<ReactPlayer
url={require("../Manuales/MANUALCOMERCIAL.mp4")}
width="50%"
height="50%"
controls
playing
muted
loop


/>
</center>
</div>
</div>
</div>
</div>
</div>
    </div>
  )
}

export default ManualComercial